<div class="container menu-print">
    <div class="row">
        <!-- Left Column -->
        <div class="col-md-6">
            <ng-container *ngFor="let group of leftGroups">
                <h4 class="group-title">{{ group }}</h4>
                <div *ngFor="let item of groupedMenu[group]" class="menu-item">
                    <span class="item-name">{{ item.itemName }}</span>
                    <span class="item-price">₹{{ item.salePrice }}</span>
                </div>
            </ng-container>
        </div>

        <!-- Right Column -->
        <div class="col-md-6">
            <ng-container *ngFor="let group of rightGroups">
                <h4 class="group-title">{{ group }}</h4>
                <div *ngFor="let item of groupedMenu[group]" class="menu-item">
                    <span class="item-name">{{ item.itemName }}</span>
                    <span class="item-price">₹{{ item.salePrice }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</div>